import type { ReactNode } from 'react';
import { unitIsTight } from './format.ts';
import styles from './Unit.module.css';

/* ==========================================================================
   The unit beside a number.

   `format.ts` states the rule — `%` and `°` are typographic suffixes of the
   numeral, every other unit takes a thin space — and this is the only place
   that implements it. It was implemented eight times before, at seven
   different widths, which is how one `/fleet/list` row came to print
   `0.46 m/s` at 3.7px and `39 °C` at 6.7px 320px apart, and how the same
   battery reading printed `79.9 %` on the robot page and `80%` in the table.

   A caller that needs a different SIZE or INK passes its own class; it must
   not pass a margin. The gap is not a surface's to choose.
   ========================================================================== */
export function Unit({
  unit,
  className,
}: {
  unit: string;
  className?: string | undefined;
}): ReactNode {
  return (
    <span
      className={className === undefined ? styles.unit : `${styles.unit} ${className}`}
      data-tight={unitIsTight(unit)}
    >
      {unit}
    </span>
  );
}
